import React from "react";
import { useIntl } from "react-intl";
import { notifySuccess } from "../utils/notifications.jsx";
import Modal from "@ignitesales/react-modal";
import ConnectedShareViaEmail from "@ignitesales/social-share-email/src/ConnectedShareViaEmail";
import classnames from "classnames";

const ShareViaEmailModal = ({ active, onClose, className }) => {
  const intl = useIntl();
  const classes = classnames(className, "shareViaEmail");

  const onEmailSent = () => {
    notifySuccess("shareViaEmail.submitted");
    onClose();
  };

  const onCloseClick = () => {
    onClose();
  };

  return (
    <Modal
      show={active}
      className={classes}
      title={intl.formatMessage({ id: "shareViaEmail.title" })}
      onClose={onCloseClick}
      nodeId="root"
      closeBtn={
        <i className="fa fa-times-circle" role="img" aria-label="Close" />
      }
    >
      <ConnectedShareViaEmail onSubmit={onEmailSent} hasBeenClicked={active} />
    </Modal>
  );
};

export default ShareViaEmailModal;
